export const GAME_TITLE = 'Rudle'

export const WIN_MESSAGES = ['Прекрасная работа!', 'Потрясающий', 'Отличная работа!']
export const GAME_COPIED_MESSAGE = 'Игра скопирована в буфер обмена'
export const ABOUT_GAME_MESSAGE = 'Об этой игре'
export const NOT_ENOUGH_LETTERS_MESSAGE = 'Недостаточно букв'
export const WORD_NOT_FOUND_MESSAGE = 'Слово не найдено'
export const CORRECT_WORD_MESSAGE = (solution: string) =>
  `Слово было ${solution}`
export const ENTER_TEXT = 'ВВОД'
export const DELETE_TEXT = 'УДАЛИТЬ'
export const STATISTICS_TITLE = 'Статистика'
export const GUESS_DISTRIBUTION_TEXT = 'Угадай распределение'
export const NEW_WORD_TEXT = 'Новое слово через '
export const SHARE_TEXT = 'Поделитесь'
export const TOTAL_TRIES_TEXT = 'Всего попыток'
export const SUCCESS_RATE_TEXT = 'Степень успеха'
export const CURRENT_STREAK_TEXT = 'Текущая серия'
export const BEST_STREAK_TEXT = 'Лучшая серия'
